import { WorkspaceLogoDTO } from 'wisestep-api';

export const logoPayload: WorkspaceLogoDTO = {
  s3Url: '',
  logoType: 'LOGO',
  modules: [],
  organizationEntities: [],
  workspaceId: '',
};
